import { useContext } from 'react';
import Theme from '../contexts/Theme';
import { ThemeContext } from '../contexts/Theme/ThemeProvider';

function useTheme() {
  const { darkMode } = useContext(ThemeContext);

  return {
    isDarkMode: darkMode,
  };
}

export { useTheme };
